import React from "react";
import {
  Button,
  Dialog,
  DialogSurface,
  DialogTitle,
} from "@fluentui/react-components";
import MaterialReactTable, { MRT_ColumnDef } from "material-react-table";
import { ReportParameter } from "../../../types/reportTypes";

interface PopupState {
  data: any[];
  selected: any | null;
  total: number;
  isOpen: boolean;
  pagination: { pageIndex: number; pageSize: number };
  searchQuery: string;
  rowSelection: { [key: string]: boolean };
}

interface PopupTableProps {
  param: ReportParameter;
  popupState: PopupState;
  onClose: () => void;
  onSelect: (selected: any) => void;
  onRowSelectionChange: (updater: any) => void;
  onPaginationChange: (updater: any) => void;
  onGlobalFilterChange: (value: string) => void;
}

const PopupTable: React.FC<PopupTableProps> = ({
  param,
  popupState,
  onClose,
  onSelect,
  onRowSelectionChange,
  onPaginationChange,
  onGlobalFilterChange,
}) => {
  const getColumnsForPopup = (param: any): MRT_ColumnDef<any>[] => {
    // Ensure we use the attributes array from reportConfig (param.apiEndpoint?.attributes)
    if (param.apiEndpoint && Array.isArray(param.apiEndpoint.attributes)) {
      return param.apiEndpoint.attributes.map((attr: any) => ({
        accessorKey: attr.value, // This is the value from reportConfig
        header: attr.label,
      }));
    }
    return [];
  };

  return (
    <Dialog
      open={popupState.isOpen}
      onOpenChange={(_, { open }) => {
        if (!open) {
          onClose();
        }
      }}
    >
      <DialogSurface>
        <DialogTitle>{param.placeholder}</DialogTitle>
        <MaterialReactTable
          columns={getColumnsForPopup(param)}
          data={popupState.data || []}
          enableColumnFilters={false}
          enableColumnActions={false}
          enableDensityToggle={false}
          enableFullScreenToggle={false}
          enableHiding={false}
          positionToolbarAlertBanner="none"
          enableRowSelection
          enablePagination={true}
          manualPagination={true}
          enableMultiRowSelection={param.multiSelect}
          rowCount={popupState.total || 0}
          state={{
            pagination: popupState.pagination || {
              pageIndex: 0,
              pageSize: 10,
            },
            globalFilter: popupState.searchQuery || "",
            rowSelection: popupState.rowSelection || {},
          }}
          onRowSelectionChange={onRowSelectionChange}
          onGlobalFilterChange={(value) => onGlobalFilterChange(value || "")}
          enableGlobalFilter={true}
          onPaginationChange={onPaginationChange}
          muiTableContainerProps={{
            style: {
              height: "calc(100vh - 400px)",
            },
          }}
          initialState={{
            density: "compact",
          }}
          muiTablePaginationProps={{
            rowsPerPageOptions: [10],
            showFirstButton: true,
            showLastButton: true,
          }}
          muiSearchTextFieldProps={{
            placeholder: `Search ${param.label}...`,
            sx: { minWidth: "300px" },
          }}
        />
        <div className="dialog_action_button">
          <Button onClick={onClose}>Cancel</Button>
          <Button
            onClick={() => {
              const selected = popupState.selected;
              if (
                selected &&
                (Array.isArray(selected) ? selected.length > 0 : true)
              ) {
                onSelect(selected);
                onClose();
              }
            }}
            disabled={
              !popupState.selected ||
              (Array.isArray(popupState.selected) &&
                popupState.selected.length === 0)
            }
          >
            Select
          </Button>
        </div>
      </DialogSurface>
    </Dialog>
  );
};

export default PopupTable;
